import Auth from '../auth/Auth';
import BidPeriod from '../models/BidPeriod';
import { WebClient } from './WebClient'

class ApiBidPeriod extends WebClient {
    async getBidPeriods(): Promise<BidPeriod[]> {
        const url = "/bidperiod";

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data || [];
            }
            return [];
        }).catch(() => { return []; });
    }

    async updateBidPeriod(data: BidPeriod): Promise<boolean> {
        return this.put("/bidperiod", data, Auth.getAuthToken()).then(res => {
            return res.status === 200;
        }).catch(() => { return false; });
    }

     async getCurrentBidPeriod(): Promise<BidPeriod> {
        const url = "/bidperiod/current";

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data;
            }
            return;
        }).catch(() => { return; });
    }
}

export default new ApiBidPeriod();
